import PrintCompiler from "#src/compiler/PrintCompiler"
import type PrintCompilerOptions from "#src/interfaces/PrintCompilerOptions"

const createCompiler = (options: PrintCompilerOptions) => {
  return new PrintCompiler(options)
}

export { createCompiler }
